<template>
    <div class="modal-container">
        <div class="modal-header">
            <h4 class="modal-title">Map Enterprise Agreements</h4>
            <md-button class="md-simple md-just-icon md-round modal-default-button" @click.stop="$modal.hide">
                <md-icon>clear</md-icon>
            </md-button>
        </div>
        <div class="modal-body">
            <form-wrapper :validator="$v" class="form-wrapper">
                <TeamsAutocomplete
                    ref="teamsRef"
                    label="Team"
                    placeholder=""
                    :should-focus="false"
                    :is-required="true"
                    @input="searchCompleted"
                />
            </form-wrapper>
            <template v-if="team && team.teamId">
                <div class="detail-group">
                    <label class="label">Company:</label>
                    <span class="value">{{ team.company }}</span>
                </div>
                <div class="detail-group">
                    <label class="label">Status:</label>
                    <span class="value">{{ team.status }}</span>
                </div>
            </template>
            <template v-else>
                <p>No team selected</p>
            </template>
            <!-- intentional blank spaces -->
            <p></p>
            <p></p>
        </div>
        <div class="modal-footer">
            <md-button class="dialog-button md-primary" @click.stop="mapAgreements">Map Agreement/s</md-button>
            <md-button class="dialog-button md-default" @click.stop="$modal.hide">Cancel</md-button>
        </div>
    </div>
</template>

<script>
import { handleRequests, showErrorMessage } from '@/helpers';
import { required } from 'vuelidate/lib/validators';
import { GeneralMixin } from '@/mixins/GeneralMixin';
import { TeamsAutocomplete } from '@/components';

export default {
    name: 'MapEntAgreementToTeamModal',
    components: { TeamsAutocomplete },
    mixins: [GeneralMixin],
    props: {
        selectedEntAgreementIds: { type: Array, required: true },
        resolve: {
            type: Function,
            default: () => {}
        }
    },
    data() {
        return {
            team: {
                teamId: null,
                status: null,
                company: null,
                teamCarriers: []
            }
        };
    },
    validations() {
        return {
            team: {
                teamId: { required }
            }
        };
    },
    methods: {
        async mapAgreements() {
            this.$v.$touch();
            if (this.$v.$invalid) 
                return;

            this.$_handleLoaderState(
                true,
                `Mapping ${this.selectedEntAgreementIds.length} Enterprise Agreement/s to ${this.team.company}`
            );

            try {
                const payload = {
                    method: 'post',
                    data: {
                        teamId: this.team.teamId,
                        enterpriseAgreementIds: this.selectedEntAgreementIds
                    }
                };
                const api = `/api/billings/support/link-agreements/${this.team.teamId}`;
                const { data } = await handleRequests(api, payload);

                if (data) {
                    this.$notify({
                        message: 'Mapping successful.',
                        type: 'success'
                    });

                    this.resolve(true);
                } else {
                    showErrorMessage(this, 'Mapping failed.');
                }
            } catch (e) {
                const message = 'Mapping failed.';
                showErrorMessage(this, message, e);
            } finally {
                this.$_handleLoaderState(false);
            }
        },
        searchCompleted(args) {
            if (args) {
                this.team = { ...args };
            } else {
                this.team = {};
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.detail-group {
    padding: 2px 16px;
    margin: 5px 0;
    font-size: 0.9em;
    .label {
        display: inline-block;
        width: 100px;
        margin-right: 4px;
        vertical-align: top;
        font-weight: 400;
    }

    .value {
        display: inline-block;
        width: calc(100% - 105px);
        vertical-align: top;
        a {
            color: #2b93ff;
        }
    }
}
</style>
